import React from 'react';
import { Box, Container, Heading, Text, Link } from 'theme-ui';
const MORE_INFO_DATA = {
  title: 'Learn more about FUNBLE!',
  text:
    'FUNBLE is a FinTech company based on Blockchain technology.\n Check out the technical expertise and project experience held by Funble.',
  button: {
    link: '/about-funble',
    label: 'MORE INFO',
  },
};
const MoreInfo = () => {
  const { title, text, button } = MORE_INFO_DATA;
  return (
    <Box as="section" id="more-info" sx={styles.section}>
      <Container>
        <Heading as="h2">{title.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}</Heading>
        <Text as="p">{text.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}</Text>
        <Link sx={styles.button} href={button.link} target="_blank" 
          rel="noopener noreferrer" 
          >
          {button.label}
        </Link>
      </Container>
    </Box>
  );
};

export default MoreInfo;

const styles = {
  section: {
    pb: ['70px', null, '80px', null, '95px', null, '110px'],
    pt: ['65px', null, '75px', null, '85px', null, '95px'],
    backgroundColor: '#f4f4f7',
    textAlign: 'center',
    h2: {
      color: 'black',
      fontFamily: 'archivo',
      fontSize: ['24px', '28px', '32px', '36px', null, '40px'],
      fontWeight: 600,
      lineHeight: 1.4,
      letterSpacing: '-1px',
      mb: ['12px', null, '15px', null, '20px'],
    },
    p: {
      fontSize: ['15px', null, '16px', null, '18px'],
      lineHeight: [1.9, null, 2],
      color: 'text_secondary',
      maxWidth: '700px',
      mx: 'auto',
      mb: ['25px', null, '30px', '35px', null, '45px'],
    },
  },
  button: {
    color: 'heading_secondary',
    letterSpacing: ' -0.16px',
    fontSize: ['13px', '14px', '15px'],
    padding: ['14px 20px 13px', '14px 25px 13px', '17px 25px 15px'],
    lineHeight: 1,
    fontWeight: 700,
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    display: 'inline-flex',
    alignItems: 'center',
  },
};
